import { z } from 'zod';

interface ContactInfo {
  name?: string;
  icon?: string;
  addressLine1?: string;
  addressLine2?: string;
}

const ContactInfo = z.object({
  name: z.string().optional(),
  icon: z.string().optional(),
  addressLine1: z.string().optional(),
  addressLine2: z.string().optional(),
});

export { ContactInfo };
